export const containerChoiceCard =
  'flex flex-col items-center justify-between my-3 md:my-0';

export const tutorialContainerCustomClass =
  'flex flex-col md:flex-row justify-center md:justify-between md:px-[30px] md:mt-[23px]';
